import { Tenant } from "../../globalDomain";
import * as classes from "./CountryFlag.css";
import { ReactComponent as CzFlag_ } from "./cz.svg";
import { ReactComponent as SkFlag_ } from "./sk.svg";

type Props = {
  tenant?: Tenant;
};

export function CountryFlag(props: Props) {
  switch (props.tenant) {
    case "CZ":
      return <CzFlag_ aria-label={"CZ"} className={classes.flag} width={32} />;
    case "SK":
      return <SkFlag_ aria-label={"SK"} className={classes.flag} width={32} />;
    default:
      return <></>;
  }
}
